export default () => {
  let prevScrollPos = window.pageYOffset;
  const header = document.querySelector('.js-header');

  window.addEventListener('scroll', function() {
    const currentScrollPos = window.pageYOffset;

    if (currentScrollPos > 300) {
      header.classList.add('header--fixed');
      if (currentScrollPos < prevScrollPos) {
        header.classList.add('header--scroll-back');
      } else {
        header.classList.remove('header--scroll-back');
      }
    } else {
      header.classList.remove('header--fixed', 'header--scroll-back');
    }

    prevScrollPos = currentScrollPos;
  });
}
